
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { NotificationModule } from "@/store/modules/notification";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { UserModule } from "@/store/modules/user";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
  },
})
export default class Search extends Vue {
  @Prop() searchStatus!: boolean;
  @Prop() hideProfile!: boolean;
  notification = NotificationModule.countNewNotif;
  textSearch: string | null = null;
  userDetail = UserModule.userDetail;
  onSubmitSearch() {
    if (this.$route.name === "ticket-search" || this.$route.name === "ticket") {
      this.$emit("onClickSubmit", this.textSearch);
    } else if (this.$route.name === "progress") {
      this.$emit("onClickSubmit", this.textSearch);
    } else {
      this.$router.push({ path: "ticket/" + this.textSearch });
    }
  }
}
